import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './PlanItemDragList.css';
import PlanItemDragListItem from "./PlanItemDragListItem";

export default class PlanItemDragList extends Component {
    handleClick(task, isActive, isDoubleClick) {
        this.props.onItemSelect((isActive && task) || null, isDoubleClick);
    }

    render() {
        let classNames = ["PlanItemDragList"];
        let items = [];

        if (this.props.tasks) {
            for (let i = 0; i < this.props.tasks.length; i++) {
                let _task = this.props.tasks[i];
                items.push(<PlanItemDragListItem task={_task}
                                                 key={`drag_${_task.id}`}
                                                 onClick={this.handleClick.bind(this, _task)}
                                                 selected={this.props.value === _task.id}
                />);
            }
        }

        return (
            <div className={classNames.join(' ')}>
                {items}
            </div>
        );
    }
}

PlanItemDragList.propTypes = {
    tasks: PropTypes.array.isRequired,
    value: PropTypes.number,
    onItemSelect: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/Portal/Planner/PlanItemDragList.js